import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';


@Pipe({
  standalone: false,
  name: 'localize',
  pure: false
})
export class LocalizePipe implements PipeTransform {

  constructor(private localization : LocalizationService)
  {  }

  transform(value: any, args?: any): any {
    if (value == null) return value;

    // Data bound { de, en } texts: pick the active language.
    if (typeof value === 'object') return value[this.localization.language];

    // Plain strings: fall back to the jobsite dictionary lookup.
    return this.localization.localize(value);
  }

}
